module.exports = __webpack_public_path__ + "static/media/Hart.a114cc27.JPG";